import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoicingCutoffCostCenterModalModel } from 'src/app/models/tables/invoicing/invoicing-cutoff-cost-center-modal.model';
import { InvoicingCutoffDetailRegisterTable } from 'src/app/models/tables/invoicing/invoicing-cutoff-detail-register-table.model';
import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { InvoicingCutoffDetailModel } from './../../models/invoicing/invoicing-cutoff-detail.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { InvoicingCutoffInvoicingConceptModal } from 'src/app/models/tables/invoicing/invoicing-cutoff-invoicing-concept-modal.model';

@Injectable({
  providedIn: 'root'
})
export class InvoicingCutoffDetailService {

  constructor(private _httpClient: HttpClient) { }

  createInvoicingCutoffDetail(invoicingCutoffId: number, costCenterIds: Array<number>): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.CreateInvoicingCutoffDetail}/${invoicingCutoffId}`,
      costCenterIds);
  }

  deleteInvoicingCutoffDetail(invoicingCutoffDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.DeleteInvoicingCutoffDetail}`,
      invoicingCutoffDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllInvoicingCutoffDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetAllInvoicingCutoffDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCostCenters(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetColumnsForCostCenters}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForInvoicingConcepts(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetColumnsForInvoicingConcepts}`);
  }

  getColumnsForRegisterTable(deployBy: boolean): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetColumnsForRegisterTable}/${deployBy}`);
  }

  getCostCentersForInvoicingCutoffAsync(invoicingCutoffId: number, page: number, limit: number,
    columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoicingCutoffCostCenterModalModel>> {
    const params = new HttpParams().set('invoicingCutoffId', invoicingCutoffId).set('page', page)
      .set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<InvoicingCutoffCostCenterModalModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetCostCentersForInvoicingCutoffAsync}`,
      filters, { params: params }
    );
  }

  getInvoicingConceptsForInvoicingCutoffAsync(invoicingCutoffId: number, page: number, limit: number,
    columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoicingCutoffInvoicingConceptModal>> {
    const params = new HttpParams().set('invoicingCutoffId', invoicingCutoffId).set('page', page)
      .set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<InvoicingCutoffInvoicingConceptModal>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetInvoicingConceptsForInvoicingCutoffAsync}`,
      filters, { params: params }
    );
  }

  getInvoicingCutoffDetailById(invoicingCutoffDetailId: number): Observable<InvoicingCutoffDetailModel> {
    return this._httpClient.get<InvoicingCutoffDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetInvoicingCutoffDetailById}/${invoicingCutoffDetailId}`);
  }

  getInvoicingCutoffDetailsForRegisterTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, deployByPreinvoicing: boolean,
    invoicingCutoffId: number, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoicingCutoffDetailRegisterTable>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('deployByPreinvoicing', deployByPreinvoicing);

    return this._httpClient.post<PagedResponseModel<InvoicingCutoffDetailRegisterTable>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.GetInvoicingCutoffDetailsForRegisterTable}/${invoicingCutoffId}`,
      filters, { params: params }
    );
  }

  thereDetailsWithoutMovements(invoicingCutoffId: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.ThereDetailsWithoutMovements}/${invoicingCutoffId}`);
  }

  updateInvoicingCutoffDetail(invoicingCutoffContract: InvoicingCutoffDetailModel): Observable<InvoicingCutoffDetailModel> {
    return this._httpClient.put<InvoicingCutoffDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingCutoffDetail.UpdateInvoicingCutoffDetail}`,
      invoicingCutoffContract);
  }

}
